import { getErrorMessage, getPostAuthRedirect } from "@/utils";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../contexts/AuthContext";
import { useBAACurrentVersion, useBAAStatusData } from "../../hooks/baa";
import { BAAPageView } from "./BAAPageView";

export const BAAPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const { baaStatus, isLoading: isBAAChecking } = useBAAStatusData({ enablePolling: !!user });
  const { baaVersion, isLoading, isError: fetchError } = useBAACurrentVersion();

  // Tracks whether this visit *started* needing a signature, as opposed to a
  // visitor who arrives already signed (e.g. a direct /baa visit). Only the
  // former should be redirected onward once signed — the latter must see the
  // read-only agreement instead of being bounced away immediately.
  const arrivedNeedingSignature = useRef<boolean | null>(null);
  if (arrivedNeedingSignature.current === null && !isBAAChecking && baaStatus) {
    arrivedNeedingSignature.current = baaStatus.needs_signature;
  }

  useEffect(() => {
    if (!user || isBAAChecking || !baaStatus) return;
    if (arrivedNeedingSignature.current === true && !baaStatus.needs_signature) {
      const { redirectPath } = getPostAuthRedirect();
      navigate(redirectPath, { replace: true });
    }
  }, [baaStatus, isBAAChecking, user, navigate]);

  return (
    <BAAPageView
      content={baaVersion?.content || null}
      isLoading={isLoading}
      error={fetchError ? getErrorMessage(fetchError) : null}
      showSignSection={!!user && !!baaStatus && baaStatus.needs_signature === true}
    />
  );
};
